import React from 'react';
import AlumniHeroSection from '../components/Alumni/AlumniHeroSection';
import UniqueBanner from "../components/UniqueBanner";
import BannerImg from "../assets/Institute/Grpup-pic.jpg";
import SeoContentSection from "../components/SeoContentSection";

const Alumni = () => {
  return (
    <>
    <UniqueBanner
  image={BannerImg}
  title="Teacher Training Alumni"
  subtitle="Celebrating the achievements of NIECCE graduates worldwide"
 />
 <AlumniHeroSection />
 <SeoContentSection title="Teacher Training Alumni Achievements">
   <p>
     NIECCE teacher training alumni are building meaningful careers in nursery schools, Montessori environments, pre-primary classrooms, and primary schools. Their achievements reflect the value of practical learning, professional guidance, and a strong education institute alumni network.
   </p>
   <p>
     Through alumni excellence awards, mentorship, and shared classroom experiences, graduates continue to support the next generation of educators. The NIECCE alumni community welcomes every nursery teacher training graduate to stay connected and celebrate progress together.
   </p>
 </SeoContentSection>
    </>
  );
};

export default Alumni;
